// src/components/dashboard/BookingStatistics.tsx
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";

interface BookingStats {
  total: number;
  concluidas: number;
  pendentes: number;
  canceladas: number;
  emAndamento: number;
  totalGasto: number;
}

const BookingStatistics: React.FC = () => {
  const [stats, setStats] = useState<BookingStats | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/usuarios/dashboard/bookings-statistics`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          }
        );
        setStats(res.data);
      } catch (error) {
        console.error("Erro ao buscar estatísticas de reservas:", error);
      }
    };

    fetchData();
  }, []);

  if (!stats) {
    return (
      <div className="col-xl-5 d-flex">
        <div className="card shadow-none flex-fill">
          <div className="card-body d-flex align-items-center justify-content-center">
            <p>Carregando estatísticas...</p>
          </div>
        </div>
      </div>
    );
  }

  // Dados para o gráfico radial
  const series = [
    ((stats.concluidas / stats.total) * 100) || 0,
    ((stats.emAndamento / stats.total) * 100) || 0,
    ((stats.pendentes / stats.total) * 100) || 0,
    ((stats.canceladas / stats.total) * 100) || 0,
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: { fontSize: "14px" },
          value: { fontSize: "16px" },
          total: {
            show: true,
            label: "Total",
            formatter: () => `${stats.total}`,
          },
        },
      },
    },
    labels: ["Concluídas", "Em andamento", "Pendentes", "Canceladas"],
    colors: ["#00E396", "#FEB019", "#008FFB", "#FF4560"],
  };

  return (
    <div className="col-xl-5 d-flex">
      <div className="card shadow-none flex-fill">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6>Estatísticas de Reservas</h6>
          </div>

          <div className="row">
            <div className="mb-3">
              <p className="mb-0">Total Gasto</p>
              <h3>
                R$ {stats.totalGasto.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
              </h3>
            </div>

            <div id="tours_chart">
              <ReactApexChart
                options={options}
                series={series}
                type="radialBar"
                height={280}
              />
            </div>

            <p className="fs-14 mt-2 text-muted">
              * Dados atualizados em tempo real
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingStatistics;